import deepExtend from 'deep-extend'
import ScorocodeError from './ScorocodeError'

export default {
  // todo shallow extend
  deepExtend,

  /**
   * Throw the Scorocode error
   * @param {string} code
   * @param {string} message
   */
  throwError(code: string, message: string): void {
    throw new ScorocodeError(code, message)
  },

  setReadonlyProperties(obj: object, props: string[]): void {
    if (!props) {
      return
    }

    for (const key in props) {
      if (props.hasOwnProperty(key)) {
        Object.defineProperty(obj, key, {
          configurable: true,
          enumerable: true,
          value: props[key],
        })
      }
    }
  },

  setProperties(
    obj: object,
    props: object,
    readOnlyProps: string[] = []
  ): void {
    for (const key in props) {
      if (props.hasOwnProperty(key)) {
        if (readOnlyProps.indexOf(key) !== -1) {
          Object.defineProperty(obj, key, {
            configurable: true,
            enumerable: true,
            value: props[key],
          })
        } else {
          obj[key] = props[key]
        }
      }
    }
  },

  get global(): any {
    let win

    // tslint:disable:strict-type-predicates
    if (typeof window !== 'undefined') {
      win = window
    } else if (typeof global !== 'undefined') {
      win = global
    } else if (typeof self !== 'undefined') {
      win = self
    } else {
      win = {}
    }

    return win
  },
}
